import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Nur echte OGs",
    body: "Jeder Account wird von Hand geprüft. Keine Fakes, keine geliehenen Styles – nur verifizierte OG-Skins aus den frühen Seasons, die es im Shop nie wieder geben wird.",
  },
  {
    n: "02",
    title: "Full Access, für immer",
    body: "Du erhältst vollen Zugriff mit E-Mail-Änderung. Der Account gehört dir komplett – kein geteilter Zugang, keine Rückrufe, keine Kompromisse.",
  },
  {
    n: "03",
    title: "Sofort & sicher",
    body: "Bezahlung mit PayPal oder Klarna. Nach dem Kauf gibst du deinen Epic-Namen an und wir starten die verifizierte Lieferung – schnell und diskret.",
  },
];

export const Manifesto = () => {
  return (
    <section id="manifesto" data-testid="manifesto" className="relative py-24 md:py-32 border-t border-white/10">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="max-w-2xl mb-16">
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#e2ff00] mb-4">Warum wir</div>
          <h2 className="font-display font-extrabold text-4xl md:text-6xl tracking-tight leading-[0.95]">
            Seltenheit, die man <span className="text-stroke">respektiert.</span>
          </h2>
        </div>

        <div className="border-t border-white/10">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              data-testid={`chapter-${c.n}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              className="grid md:grid-cols-[120px_1fr_1.4fr] gap-6 md:gap-10 py-10 border-b border-white/10 group hover:bg-white/[0.02] transition-colors px-2"
            >
              <div className="font-display font-extrabold text-5xl md:text-6xl text-[#27272a] group-hover:text-[#e2ff00] transition-colors">
                {c.n}
              </div>
              <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight self-center">{c.title}</h3>
              <p className="text-[#8b8b93] leading-relaxed self-center max-w-lg">{c.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
